import React, { useMemo } from 'react';
import getSmoothCurvePath from '../../Helpers/periodontalLines/getSmoothCurvePath';

interface Point {
	x: number;
	y: number;
}

interface Props {
	marginPoints: Point[];
	depthPoints: Point[];
}

const DENTToothPeriodontalLineFill = ({ marginPoints, depthPoints }: Props) => {
	const pathData = useMemo(() => {
		if (marginPoints.length === 0 || depthPoints.length === 0) return '';

		// Start with margin line (left to right)
		let path = `M ${marginPoints[0].x},${marginPoints[0].y}`;

		for (let i = 1; i < marginPoints.length; i++) {
			const prev = marginPoints[i - 1];
			const curr = marginPoints[i];

			path += getSmoothCurvePath({
				prevX: prev.x,
				prevY: prev.y,
				currX: curr.x,
				currY: curr.y,
			});
		}

		// Go to depth line at the right end and trace back (right to left)
		path += ` L ${depthPoints[depthPoints.length - 1].x},${
			depthPoints[depthPoints.length - 1].y
		}`;

		for (let i = depthPoints.length - 1; i > 0; i--) {
			const curr = depthPoints[i];
			const prev = depthPoints[i - 1];

			const cp1x = curr.x - (curr.x - prev.x) / 3;
			const cp1y = curr.y;
			const cp2x = prev.x + (curr.x - prev.x) / 3;
			const cp2y = prev.y;

			path += ` C ${cp1x},${cp1y} ${cp2x},${cp2y} ${prev.x},${prev.y}`;
		}

		path += ' Z'; // Close the path
		return path;
	}, [marginPoints, depthPoints]);

	return <path d={pathData} fill='rgba(58, 168, 223, 0.3)' stroke='none' />;
};

export default DENTToothPeriodontalLineFill;
